/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Kixie from './kixie-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Kixie {...validProps} />;
}
SvgComponent.iconName = 'kixie';

export const KixieIcon = svgIconWrapper(SvgComponent);
